import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import { StepId } from 'webapp/services/wizard';

export default class WizardCreateBlockRoute extends Route {
	@service('wizard') declare wizardService: Service.Wizard;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel() {
		if (!this.wizardService.selectedSourceType?.id) {
			this.navigationService.replaceRoute('wizard');
		}

		this.wizardService.activeStep = StepId.CONNECT;
	}
}
